import { isEqual, reject } from 'lodash-es'

export const toggleArrayItem = <T>(
  arr: T[],
  item: T,
  toggle: boolean,
  pred: (item: T) => boolean = v => isEqual(v, item),
) => {
  const newArr = reject<T>(arr, pred)
  if (toggle) {
    return [...newArr, item]
  }
  return newArr
}
